import "./FireRiskLegend.css";
import { useState, useRef, useCallback } from "react";
import Draggable from "react-draggable";
import { FiEye, FiEyeOff } from "react-icons/fi";

export const LEVELS = [
  { label: "TRÈS ÉLEVÉ", color: "#e80201", value: 3 },
  { label: "ÉLEVÉ",      color: "#ed6204", value: 2 },
  { label: "MODÉRÉ",     color: "#fdd801", value: 1 },
  { label: "FAIBLE",     color: "#2e742f", value: 0 },
];

const DEPARTEMENTS_COLOR = "rgba(28, 252, 252, 1)";

const FireRiskLegend = ({
  onClose,
  visibleLevels,
  onToggleLevel,
  layerOpacity,
  onOpacityChange,
  departementsVisible,
  onToggleDepartements,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const nodeRef = useRef(null);

  const handleStart = useCallback(() => setIsDragging(true), []);
  const handleStop  = useCallback(() => setIsDragging(false), []);

  return (
    <Draggable
      nodeRef={nodeRef}
      handle=".frl-header"
      cancel="button, input, .frl-opacity-slider"
      bounds={false}
      defaultPosition={{ x: 0, y: 0 }}
      onStart={handleStart}
      onStop={handleStop}
    >
      <div ref={nodeRef} className={`fire-risk-legend ${isDragging ? "dragging" : ""}`}>
        <div className="frl-header">
          <span className="frl-title">Couches de risque</span>
          <button
            className="frl-close-btn"
            onClick={onClose}
            aria-label="Fermer la légende"
          >
            ✕
          </button>
        </div>

        {/* ── Risk levels ── */}
        <div className="frl-items">
          {LEVELS.map(({ label, color, value }) => {
            const visible = visibleLevels.includes(value);
            return (
              <div className="frl-item" key={label}>
                <span
                  className="frl-bar"
                  style={{ background: color, opacity: visible ? 1 : 0.25 }}
                />
                <div className="frl-text">
                  <span className="frl-level" style={{ opacity: visible ? 1 : 0.4 }}>
                    {label}
                  </span>
                </div>
                <button
                  className="frl-eye-btn"
                  style={{
                    borderColor: visible ? color : "var(--map-border)",
                    color: visible ? color : "var(--map-text-muted)",
                  }}
                  onClick={(e) => { e.stopPropagation(); onToggleLevel(value); }}
                  aria-label={visible ? "Masquer" : "Afficher"}
                  title={visible ? "Masquer" : "Afficher"}
                >
                  {visible ? <FiEye size={14} strokeWidth={2} /> : <FiEyeOff size={14} strokeWidth={2} />}
                </button>
              </div>
            );
          })}
        </div>

        {/* ── Divider ── */}
        <div className="frl-divider" />

        {/* ── Other layers ── */}
        <div className="frl-items">
          <div className="frl-item">
            <span
              className="frl-bar"
              style={{
                background: DEPARTEMENTS_COLOR,
                opacity: departementsVisible ? 1 : 0.25,
              }}
            />
            <div className="frl-text">
              <span className="frl-level" style={{ opacity: departementsVisible ? 1 : 0.4 }}>
                DÉPARTEMENTS
              </span>
            </div>
            <button
              className="frl-eye-btn"
              style={{
                borderColor: departementsVisible ? DEPARTEMENTS_COLOR : "var(--map-border)",
                color: departementsVisible ? DEPARTEMENTS_COLOR : "var(--map-text-muted)",
              }}
              onClick={(e) => { e.stopPropagation(); onToggleDepartements(); }}
              aria-label={departementsVisible ? "Masquer" : "Afficher"}
              title={departementsVisible ? "Masquer" : "Afficher"}
            >
              {departementsVisible
                ? <FiEye size={14} strokeWidth={2} />
                : <FiEyeOff size={14} strokeWidth={2} />}
            </button>
          </div>
        </div>

        {/* ── Opacity ── */}
        <div className="frl-opacity-row">
          <span className="frl-opacity-label">OPACITÉ</span>
          <input
            type="range"
            className="frl-opacity-slider"
            min={0}
            max={1}
            step={0.01}
            value={layerOpacity}
            onChange={(e) => onOpacityChange(parseFloat(e.target.value))}
          />
          <span className="frl-opacity-value">
            {Math.round(layerOpacity * 100)}%
          </span>
        </div>
      </div>
    </Draggable>
  );
};

export default FireRiskLegend;